import { memo, useRef } from 'react';

import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';

import { useStoreMobx } from 'mobx/helpers';

const LogoutListener = observer(() => {
  const store = useStoreMobx();
  const navigate = useNavigate();
  const loggingOutRef = useRef(false);

  const clearStore = () => {
    try {
      store.logOut();
    } catch (e) {
      console.error(e);
    }
  };

  if (!loggingOutRef.current && store.redirectionToSsoNeeded) {
    const currentUrl = window.location.href;
    loggingOutRef.current = true;
    clearStore();
    navigate(`/login?backTo=${encodeURIComponent(currentUrl)}`);
  }

  return null;
});

export default memo(LogoutListener);
